export const BASE_URL = process.env.REACT_APP_BACKEND_URL ?? 'https://api.reembolso.unionit.com.br';
// export const BASE_URL = process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:8080';
// export const BASE_URL = process.env.REACT_APP_BACKEND_URL ?? 'http://192.168.0.26:1080';
